var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57807 6.875L7.4499 4.93383L6.5501 4.06616L3.5501 7.17727L3.11597 7.62748L3.56648 8.06131L6.56648 10.9502L7.43353 10.0498L5.4347 8.125H12.0002C13.8973 8.125 15.3752 9.66349 15.3752 11.5C15.3752 13.328 13.8224 14.875 12.0002 14.875V16.125C14.5113 16.125 16.6252 14.0198 16.6252 11.5C16.6252 8.98868 14.6031 6.875 12.0002 6.875H5.57807Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.0e39a0fd267202c6459fc94e2f0c99ae.svg";
export { ForwardRef as ReactComponent };